import React, { useState } from 'react';

import {
  Eventswebinars,
  EventsWebinarsTitle,
  EventsWebinarFigure,
  EventsCard,
  Card,
  CompoundInterestConstancy,
  SuperPowerCards,
  CardFooter
} from './eventsWebinarsSeasons.styles';

export default function EventsWebinarsSeasons() {
  const [userData, setUserData] = useState({});

  const handleEmail = (e) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (re.test(String(e.target.value).toLowerCase()) === true) {
      userData[e.target.name] = e.target.value;
    } else {
      userData[e.target.name] = undefined;
    }
  };

  return (
    <Eventswebinars>
      <EventsWebinarsTitle>
        <div>
          <h2>
            Webinar
            <span> Inversiones Sustentables </span>|
          </h2>
          <h3> Primera temporada.</h3>
          <p>¿Cómo utilizar nuestros servicios?</p>
          <img
            src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/imageWebinar.png`}
            alt="imagen Acerca de nosotros"
          />
        </div>
      </EventsWebinarsTitle>
      {/* <h4>Escúchanos en vivo todos los martes a las 8:30 am por Facebook Live. Todos los programas están disponibles en FinSphera, en Facebook live, en nuestro canal de YouTube y en Spotify.</h4> */}
      <EventsWebinarFigure>
        <EventsCard>
          <Card>
            <figure>
              <img
                src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/libraryLandscape.png`}
                alt="library landscape"
              />
            </figure>
            <p>Jueves 21 de Octubre de 2021</p>
            <CardFooter>
              <div>
                <figure>
                  <img
                    src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/iconCalendar.png`}
                    alt="Vector 1"
                  />
                </figure>
                <p>27</p>
                <h4>ABR</h4>
              </div>
              <div>
                <figure>
                  <img
                    src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/iconTimer.png`}
                    alt="Vector 1"
                  />
                </figure>
                <p>8:30</p>
                <h4>A.M.</h4>
              </div>
              <div>
                <figure>
                  <img
                    src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_inv_dash_companyDetail_facebook.png`}
                    alt="Vector 1"
                  />
                </figure>
                <p>LIVE</p>
              </div>
              <figure>
                <img src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/image_BIVA.png`} alt="BIVA" />
              </figure>
            </CardFooter>
          </Card>
          <Card>
            <figure>
              <img
                src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/libraryLandscape.png`}
                alt="library landscape"
              />
            </figure>
            <p>9 am a 2 pm GMT-5</p>
            <CardFooter>
              <div>
                <figure>
                  <img
                    src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/iconCalendar.png`}
                    alt="Vector 1"
                  />
                </figure>
                <p>27</p>
                <h4>ABR</h4>
              </div>
              <div>
                <figure>
                  <img
                    src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/iconTimer.png`}
                    alt="Vector 1"
                  />
                </figure>
                <p>8:30</p>
                <h4>A.M.</h4>
              </div>
              <div>
                <figure>
                  <img
                    src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_inv_dash_companyDetail_facebook.png`}
                    alt="Vector 1"
                  />
                </figure>
                <p>LIVE</p>
              </div>
              <figure>
                <img src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/image_AII.png`} alt="BIVA" />
              </figure>
            </CardFooter>
          </Card>
          <Card>
            <figure>
              <img
                src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/libraryLandscape.png`}
                alt="library landscape"
              />
            </figure>
            <p>Entrada Libre</p>
            <CardFooter>
              <div>
                <figure>
                  <img
                    src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/iconCalendar.png`}
                    alt="Vector 1"
                  />
                </figure>
                <p>27</p>
                <h4>ABR</h4>
              </div>
              <div>
                <figure>
                  <img
                    src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/iconTimer.png`}
                    alt="Vector 1"
                  />
                </figure>
                <p>8:30</p>
                <h4>A.M.</h4>
              </div>
              <div>
                <figure>
                  <img
                    src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_inv_dash_companyDetail_facebook.png`}
                    alt="Vector 1"
                  />
                </figure>
                <p>LIVE</p>
              </div>
              <figure>
                <img src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/image_AII.png`} alt="BIVA" />
              </figure>
            </CardFooter>
          </Card>
        </EventsCard>
      </EventsWebinarFigure>
      <h3>¡No te pierdas nuestros próximos Webinars!</h3>
      <CompoundInterestConstancy>
        <SuperPowerCards>
          <div>
            <h5>Educación Financiera</h5>
            <p>
              Aprende a utilizar los servicios financieros para cumplir con tus objetivos a corto,
              median y largo plazo. ¡No les tengas miedo y aumenta tus capacidades financieras!
            </p>
          </div>
          <div>
            <h5>Inclusión Financiera</h5>
            <p>
              Ahora que ya sabes como utilizar los servicios financieros, contrata los que más te
              convengan.
            </p>
          </div>
          <div>
            <h5>Salud y Libertad Financiera</h5>
            <p>
              Distruta de los beneficios de las Inversiones para que estés protegido en caso de una
              emergencia. ¡Invierte para pagar tus estudios o una casa y disfruta de tu jubilación
              viajando!
            </p>
          </div>
        </SuperPowerCards>
      </CompoundInterestConstancy>
    </Eventswebinars>
  );
}
